<template>
    <div class="upload-panel-wrapper" v-drag :class="{minHeight:isMaximised === true}">
        <div class="close-or-min-panel">
            <div class="back-button-wrapper" v-if="isFilters"><back-icon v-on:click.native="isFilters = false"></back-icon></div>
            <div style="text-align:start;width:90%;padding:9px;">Jobs</div>
            <!-- <div v-if="!isFilters && inProgressJobsCount != undefined" title="Queued and In progress job count" style="text-align:start;width:90%;padding:9px;">{{selectedActionName.label + " : " + inProgressJobsCount + " " + 'file(s)'}}</div> -->
            <div>
                <svg xmlns="http://www.w3.org/2000/svg"  width="22" height="22" fill="currentColor" style="margin-inline-end:18px;margin-top:10px;"  :class="{active: isFilters}" v-on:click="isFilters = true" class="bi bi-funnel-fill filterpanel" viewBox="0 0 16 16">
                    <title>Filter</title>
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.74l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"/>
                </svg>
            </div>
            <div v-on:click="minMaxPanel()">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin-inline-end:12px;" v-show="!isMaximised" width="30" height="30" fill="currentColor" class="bi bi-chevron-down mt-1 close-icon" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" style="margin-inline-end:12px;" v-show="isMaximised" width="30" height="30" fill="currentColor" class="bi bi-chevron-up mt-1 close-icon" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                </svg>
            </div>
            <div>
            <cancel-icon @click.native="closePanel" class="close-icon mt-1" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon>
    </div>
        </div>
        <div class="upload-progress-bar" v-show="!isMaximised && !isFilters" v-on:scroll="loadMoreJobs($event)">
            <div v-if="allJobsList.length == 0" style="color:#666">
                No jobs found
            </div>
            <div v-for="file in allJobsList" :key="file._id" v-else class="d-flex h-100 upload-bars" :style="{'border-left':'2px solid'+ file.randomColor}">
                <template v-if="file.job_name != 'Download'" style="margin-bottom:12px;">
                    <div class="edit-upload-info mr-1 ml-1">
                        <div v-html="getSvgIconsOfMediaTypes(file.data)" class="svg-icons-display"></div>
                    </div>
                    <!-- <div class="edit-upload-info">
                        <svg xmlns="http://www.w3.org/2000/svg" v-show="!isMaximised" width="16" height="16" fill="currentColor" @click="openUploadWindow()" class="bi bi-pen-fill" viewBox="0 0 16 16">
                            <path d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                        </svg>
                    </div> -->
                    <div class="file-name-with-progress-bar-wrapper" >
                        <div class="file-name-wrapper">
                            <div class="file-name-display" :title="file.resource_name">
                                <span v-if="file.data && file.data.slug_name">{{file.data.slug_name}}</span>
                                <span v-else>{{file.resource_name?file.resource_name:'-'}}</span>
                            </div>
                            <span style="font-size:11px;float:inline-start;color:#ac92cf;width:100%;text-align:start">{{file.job_name.toUpperCase()}}</span>
                            <span v-if="file.data && file.data.size"  style="font-size:11px;float:inline-start;color:#8d8d8d">{{humaniseSize(file.data.size) + " | "}}</span>
                            <span class="upload-status-text ml-1">{{" " + formatedDate(file.created_datetime)}}</span>
                            <div class="progress-bar-wrapper" v-if="file.state == 'IN_PROGRESS'">
                                    <div class="progress-percentage-display">{{Math.round(file.status_info.progress) + '%'}}</div>
                                    <div class="progress" v-show="!isMaximised">
                                                <div class="progress-bar" role="progressbar" :style="{width:file.status_info.progress + '%'}" :aria-valuenow="file.status_info.progress" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                    <div v-if="file.status_info && file.status_info.bandwidth" style="font-size:11px;margin-inline-start:3px;">{{humanizeBandwidth(file.status_info.bandwidth).bandwidth}} {{humanizeBandwidth(file.status_info.bandwidth).unit}}</div>
                                    <!-- <div class="progress-speed-display">
                                        {{file.bandwidth.bandwidth}} {{file.bandwidth.unit}}
                                    </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="file-upload-status-display-wrapper">
                        <div class="file-upload-status">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" v-if="file.state == 'COMPLETED'" fill="green" class="bi bi-check-circle-fill ml-2 completed-files" viewBox="0 0 16 16">
                                <title>COMPLETED</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" v-if="file.state == 'QUEUED'" class="bi bi-clock-fill ml-2" viewBox="0 0 16 16">
                                <title>QUEUED</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" v-if="file.state == 'FAILED' || file.state == 'ABORTED'" class="bi bi-x-circle-fill ml-2" viewBox="0 0 16 16">
                                <title>{{file.state}}</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dd8518" v-if="file.state == 'INITIALIZING'" class="bi bi-clock-fill ml-2" viewBox="0 0 16 16">
                                <title>INITIALIZING</title>
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                            </svg>
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#b43131" class="bi bi-x ml-2 remove-selected-file"  v-if="file.state == 'IN_PROGRESS'" :id="file.fileUID + '/' + file.jobId" v-on:click="discardSelectedFileFromUpload(file.fileUID,file.jobId,file.status)" viewBox="0 0 16 16">
                                <title>Remove File</title>
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg> -->
                        </div>
                        
                    </div>
                </template>    
            </div>
        </div>
        <div class="filters-bar" v-if="isFilters && !isMaximised">
            <ul>
                <li :class="{active:selectedActionName.action == 'Jobs'}" v-on:click="selectedJobNameFilter({action:'Jobs',label:'jobs'})">All</li>
                <li v-for="job in getJobNames()" :key="job.action_name" :value="job.action_name" :class="{active:selectedActionName.action == job.action_name}" v-on:click="selectedJobNameFilter({action:job.action_name,label:job.label})">
                    <template v-if="job.action_name != 'Download'">
                        {{job.label}}
                    </template>    
                </li>
            </ul>
        </div>
        </div>
</template>

<script>
import cancelIcon from "./InlineCancelField.vue"
import drag from '@branu-jp/v-drag'
import Utils from "../../components.utils.js";
import {  mapGetters, mapMutations, mapActions } from "vuex";
import BackButton from "../core/backButton.vue";
import Constants from "../../components.constants.js"

export default {
    directives: {
        drag
    },
    components:{
        'cancel-icon':cancelIcon,
        'back-icon':BackButton
    },
    data(){
        return{
            isMaximised:false,
            uploadedFilesCount:0,
            allJobsList:[],
            isFilters:false,
            selectedActionName:{action:"Jobs",label:"Jobs"},
            page:1,
            inProgressJobsCount:0,
        }
    }, 
    computed:{
        ...mapGetters("upload",["getUploadingFilesListState","getAllJobsToDisplayInPanel"]),
        ...mapGetters("jobs",["getAllJobsStatus"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
    },
    methods:{
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("upload",["discardFileFromUpload"]),
        ...mapMutations("upload",["abortFileUploadState","setCancelledFileUploadState","abortUpload","removeFailedFiles"]),
        ...mapActions("jobs", ["getAllJobsFromServer"]),
        ...mapGetters("privileges",["getActionListFromInMem"]),
        minMaxPanel(){
            this.isMaximised = !this.isMaximised;
        },
        humanizeBandwidth(bytes){
            return Utils.humanizeBandwidth(bytes);
        },
        humaniseSize(bytes){
            let data = Utils.humanizeSize(bytes)
            return `${data["value"]} ${data["unit"]}`
        },
        getSvgIconsOfMediaTypes(path,type){
            return Utils.determineSvgIconForType(path,type)
        },
        closePanel(){
            this.$emit("closeUploadPanel");
            Utils.unsetCookie("jobFilter");
        },
        completedFilesLength(){
            return document.getElementsByClassName("completed-files").length;
        },
        discardSelectedFileFromUpload(fileUid,jobId,status){
            if(status == "FAILED"){
                this.removeFailedFiles(jobId);
                Object.values(this.getAllJobsToDisplayInPanel);
            }else{
            if(confirm(
                `Are you sure you want to remove selected file?`
            )){
            let payload = {};
            payload.file_uid = fileUid;
            payload.job_id = jobId;
            this.abortUpload({"job_id":jobId,"data":payload});
            }else{
                return false;
            }
            }
        },  
        formatedDate(date){
            return Utils.getDateFormat(date);
        },
        getCurrentUserAllJobs(filteredJobName,isLoadmore){
            let payload = {};
            let filterBy = {};
            filterBy.user_id = this.getLoggedInUserId;
            if(filteredJobName == 'Jobs' || filteredJobName.trim() <= 0){
                delete filterBy.job_name;
            }else{
                filterBy.job_name = filteredJobName;
            }
            if(isLoadmore){
                filterBy.page = this.page;
            }else if(Object.keys(filterBy).includes("job_name")){
                delete filterBy.page;
            }else{
                filterBy.page = 1;
            }
            payload.params = filterBy;  
            this.getAllJobsFromServer(payload).then((data)=>{
                if(isLoadmore){
                    this.allJobsList = this.allJobsList.concat(data.jobs);
                }else{
                    this.allJobsList = data.jobs;
                }
                if(filteredJobName == 'Jobs' || filteredJobName.trim() <= 0){
                    this.getInprogressAndQueuedJobsCount("All")
                }else{
                    this.getInprogressAndQueuedJobsCount(filteredJobName)
                }
            });
        }, 
        getInprogressAndQueuedJobsCount(filter){
            let payload = {};
            let job_status = ["QUEUED","IN_PROGRESS"];
            if(filter == "All"){
                payload.params = {"user_id":this.getLoggedInUserId,"state":JSON.stringify(job_status)}  
            }else{
                payload.params = {"user_id":this.getLoggedInUserId,"state":JSON.stringify(job_status),"job_name":filter}  
            }
            this.getAllJobsFromServer(payload).then((data)=>{
                this.inProgressJobsCount = data.total_jobs;
            });
        },
        getJobNames(){
            return this.getActionListFromInMem().filter((action)=>action.executed_as_job == true)
        },   
        selectedJobNameFilter(filteredJobName){
            this.selectedActionName = filteredJobName;
            Utils.updateCookieByKeyName("jobFilter", filteredJobName);
            this.getCurrentUserAllJobs(filteredJobName.action,false)
        },
        loadMoreJobs(e){
            if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight) {
                this.page = this.page + 1;
                if(Utils.getCookieValue("jobFilter") != undefined && Utils.getCookieValue("jobFilter").length > 0){
                    if(Utils.getCookieValue("jobFilter") == "Jobs"){
                        this.getCurrentUserAllJobs(Utils.getCookieValue("jobFilter"),true);
                    }else{
                        this.getCurrentUserAllJobs(Utils.getCookieValue("jobFilter"),false);
                    }
                    this.selectedActionName = Utils.getCookieValue("jobFilter");
                }else{
                    this.getCurrentUserAllJobs(this.selectedActionName.action,true);
                }
            }
        },
        updateProgress(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(this.getLoggedInUserId == notification.message.user_id){
            let job_info = notification.message
            let job = this.allJobsList.filter((job_)=>job_.job_id == job_info.job_id);
            if (job.length !=0){
                job = job[0]
                Object.assign(job, job_info);
            }else{
                if(this.selectedActionName.action == "Jobs" || this.selectedActionName.action == job_info.job_name){
                    this.allJobsList.unshift(job_info);
                }
                // this.getCurrentUserAllJobs(this.selectedActionName.action,false);
            }
         }
        },
    },
    created(){ 
        if(Utils.getCookieValue("jobFilter") != undefined && Utils.getCookieValue("jobFilter").action.length > 0){
            this.getCurrentUserAllJobs(Utils.getCookieValue("jobFilter").action,false);
            this.selectedActionName = Utils.getCookieValue("jobFilter");
        }else{
            this.getCurrentUserAllJobs("Jobs",false);
        }
    },
    mounted(){
        this.addWSEventListener({eventname:Constants.jobStatusUpdateNotification, callback:this.updateProgress, parent:"UploadPanel"});
    },
    beforeDestroy(){
        this.removeWSEventListener({eventname:Constants.jobStatusUpdateNotification, callback:this.updateProgress, parent:"UploadPanel"});   
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

.active{
    color:$active-blue;
}

.filters-bar{
    max-height: 190px;
    width: 100%;
    overflow:auto;
    display:inline-block;
    ul{
        list-style-type: none;
        padding-inline-start:2px;
        li{
            text-align: start;
            margin-inline-start: 6%;
            margin-top: 9px;
        }
    }
}

.upload-panel-wrapper:hover{
    cursor: grabbing !important;
}

.upload-panel-wrapper{
    width: 400px;
    border: $secondary-border-color;
    position: absolute;
    background: $primary-background;
    bottom: 41px !important;
    top:unset !important;
    inset-inline-end: 2%;
    z-index: 9;
    max-height: 250px;
    box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -webkit-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    -moz-box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
    .close-or-min-panel{
            height: 50px;
            width:100%;
            border-bottom: $secondary-border-color;
            background: $secondary-background-color;
            text-align: end;
            padding: 5px;
            display: flex;
            justify-content: flex-end;
        }
    .upload-progress-bar{
            max-height: 190px;
            width: 100%;
            padding-top: 7px;
            overflow:auto;
            display:inline-block;
            .edit-upload-info{
                width:8%;
                padding: 5px;
                    svg{
                        position: relative;
                        inset-inline-end: 6px;
                    }
            }
            .file-name-with-progress-bar-wrapper{
                    display: inline-flex;
                    width: 93%;
                    margin-bottom: 12px;
                    .file-name-wrapper{
                        width: 99%;
                        display: inline-block;
                        .file-name-display{
                            text-align: start;
                            /* white-space: nowrap; */
                            overflow-wrap: break-word;
                            width: 277px;
                            /* overflow: hidden; */
                            /* text-overflow: ellipsis;*/
                            span{
                                    font-size: 11px;
                                    color: #dbdbdb;
                            }
                        }
                        .upload-status-text{
                            text-align: start;
                            float:inline-start;
                            font-size:11px;
                            margin-inline-start:8px;
                            color:#8d8d8d;
                        }
                        .progress-bar-wrapper{
                                display: inline-flex;
                                width: 100%;
                                .progress-percentage-display{
                                        font-size: 11px;
                                }
                                .progress{
                                    width: 67%;
                                    background: #292929;
                                    margin-inline-start: 4px;
                                    height: 10px;
                                    margin-top: 2px;
                                    border-radius: 3px;
                                }
                                .progress-speed-display{
                                        font-size: 11px;
                                        margin-inline-start: 3px;
                                }
                        }
                    }
                }
                .file-upload-status-display-wrapper{
                        width:20%;
                        .file-upload-status{
                            height: 30px;
                            margin-top: 8px;
                            display:inline-flex;
                        }
                    }
            }
        }



.edit-upload-info{
    position: relative;
    inset-inline-start:0px;
}

.minHeight{
    height:52px !important;
    bottom:41px !important;
    top: unset !important;
}

.dragged-element {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    font-size: 12px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    text-align: center;
    transition: all 0.4s linear;
    transition-property: background-color;
  }

.remove-selected-file{
  visibility:hidden;
}

.upload-bars:hover{
  .remove-selected-file{
    visibility: visible;
    position: relative;
    bottom: 6px;
  }
} 

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

// .upload-bars{
//     margin-bottom: 12px;
// }
.back-button-wrapper{
    width: 90%;
    float: inline-start;
    padding-top: 1%;
    svg{
        float: inline-start;
    }
    svg:hover{
        background: $icon-hover !important;
    }
}

.filterpanel{
    visibility: hidden;
}
.close-or-min-panel:hover{
    .filterpanel{
        visibility: visible;
    }
}
</style>



